import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-not-paid',
  templateUrl: './icon-not-paid.component.html',
  styleUrls: ['./icon-not-paid.component.scss']
})
export class IconNotPaidComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
